<template>
    <div>
        <main-object
            v-bind:headline="headline"
            v-bind:levels="levels"
            v-bind:priceType="priceType"
            v-bind:providerType="providerType"
            v-bind:show-filters="showFilters"
            v-bind:filter-start-end-keys="filterStartEndKeys"

            v-on:openForm="openForm"
            v-on:openRouteForm="openRouteForm"
            ref="mainObject"
        />
        <item-form ref="form" v-on:submit="handleSubmit" v-bind:provider-type="providerType"/>
        <route-form ref="route" v-on:submit="handleSubmit" v-bind:provider-type="providerType"/>

    </div>



</template>

<script>

import Mixin from '../tab';
import PriceMixin from './mixins'
import ItemForm from './Forms/Ferry';
import RouteForm from './Forms/Route';

import MainObject from "@components/CRUD/Item/Tabs/ProviderPrices/Main";
import {getFerryRoute} from "@utilities/api";
import moment from "moment";
import {omit} from "lodash";



export default {
    mixins: [ Mixin, PriceMixin ],

    components: {MainObject, ItemForm, RouteForm},

    data: function () {
        return {
            headline: 'Fährverbindungen',
            levels: ['level', 'route', 'priceGroup', 'Price'],
            priceType: 'ferry',
            providerType: 'provider',
            showFilters: {
                'ports': "",
                'priceGroups.timePeriods.startAt[before]': '',
                'priceGroups.timePeriods.endAt[after]': '',
                'agency.id': "",
                'agency[exists]': "",
            },
            filterStartEndKeys: ['priceGroups.timePeriods.endAt[after]', 'priceGroups.timePeriods.startAt[before]'],
        }
    },

    methods: {
        openRouteForm: function(route = {}) {
            if(route.id && !route.startPort){
                this.isLoading = true
                getFerryRoute(route.id, '?_groups[]=agency_read&_groups[]=ferry_read').then(response => {
                    route = response.data
                    this.$refs.route.setType(response.data.agency ? 'agency' : 'direct');
                    this.$refs.route.open(route);
                }).then(() => { this.isLoading = false; });
            } else {
                this.$refs.route.open(route);
            }
        },

        openForm: function (data = {}) {
            this.openPriceForm(omit(data, ['updatedAt', 'updatedBy']));
            this.$refs.form.setSettings();

        },
    }


}
</script>
